import {
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import "react-international-phone/style.css";
import React from "react";
import {
  defaultCountries,
  FlagImage,
  parseCountry,
  usePhoneInput,
} from "react-international-phone";
import { t } from "i18next";

export const Phone = ({
  value,
  name,
  onChange,
  error,
  helperText,
  type,
  ...restProps
}) => {
  const theme = useTheme();
  const isRtl = theme.direction === "rtl";
  
  const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } =
    usePhoneInput({
      defaultCountry: "qa",
      value,
      countries: defaultCountries,
      onChange: (data) => {
        onChange(data.phone);
      },
    });

  return (
    <TextField
      size="small"
      sx={{ width: "100%", borderRadius: 1, my: 1.75, height: 38 }}
      label={t("phoneNumber")}
      name={name}
      color="primary"
      error={error}
      helperText={helperText}
      placeholder={t("phoneNumber")}
      value={inputValue}
      onChange={handlePhoneValueChange}
      type={type}
      inputRef={inputRef}
      dir={theme.direction}
      InputProps={{
        [isRtl ? "endAdornment" : "startAdornment"]: (
          <InputAdornment 
            position={isRtl ? "end" : "start"} 
            sx={{ 
              mr: isRtl ? -1 : 0.25, 
              ml: isRtl ? -0.25 : -1 
            }}
          >
            <Select
              MenuProps={{
                style: {
                  height: "300px",
                  width: "360px",
                  top: "10px",
                  [isRtl ? "right" : "left"]: "-34px",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: isRtl ? "right" : "left",
                },
              }}
              sx={{
                width: "max-content",
                fieldset: {
                  display: "none",
                },
                ".MuiSelect-select": {
                  p: 1,
                  pr: isRtl ? 1 : 3,
                  pl: isRtl ? 3 : 1,
                },
                svg: {
                  [isRtl ? "left" : "right"]: 0,
                },
              }}
              value={country.iso2}
              onChange={(e) => setCountry(e.target.value)}
              renderValue={(value) => (
                <FlagImage iso2={value} style={{ display: "flex" }} />
              )}
            >
              {defaultCountries.map((c) => {
                const country = parseCountry(c);
                return (
                  <MenuItem key={country.iso2} value={country.iso2} dir={theme.direction}>
                    <FlagImage
                      iso2={country.iso2}
                      style={{ marginRight: isRtl ? 0 : "8px", marginLeft: isRtl ? "8px" : 0 }}
                    />
                    <Typography 
                      marginRight={isRtl ? 0 : "8px"}
                      marginLeft={isRtl ? "8px" : 0}
                    >
                      {country.name}
                    </Typography>
                    {theme.direction === "rtl" ? (
                      <Typography color="gray" marginLeft={1}>{country.dialCode}+</Typography>
                    ) : (
                      <Typography color="gray" marginRight={1}>+{country.dialCode}</Typography>
                    )}
                  </MenuItem>
                );
              })}
            </Select>
          </InputAdornment>
        ),
      }}
      {...restProps}
    />
  );
};